<button mat-fab color="accent">
  <mat-icon>close</mat-icon>
</button>
